import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { Field } from "@/components/kit";
import { api, errMsg } from "@/lib/api";
import { useAuth, homeFor } from "@/context/AuthContext";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      nav(params.get("next") || homeFor(data), { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Log in to manage your team or open your player app."
      footer={<>New club? <Link to="/signup" className="font-semibold text-[#CCFF00]" data-testid="login-signup-link">Register your team</Link></>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Email">
          <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" />
        </Field>
        <Field label="Password">
          <Input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" />
        </Field>
        {error && <p className="text-sm text-rose-400" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="h-11 w-full rounded-full font-bold uppercase tracking-wider" data-testid="login-submit-btn">
          {busy ? "Signing in…" : "Log in"}
        </Button>
        <Link to="/forgot-password" className="block text-sm text-slate-400 hover:text-white" data-testid="forgot-password-link">Forgot password?</Link>
      </form>
    </AuthShell>
  );
}
